import React, { useState, useEffect, useContext } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Input from "./input";
import FontAwesome from "react-fontawesome";
import Renderlist from "./renderdetail";
import Modalconfirmbranch from "./../wms/modalconfirmbranch";
const Modaldetailbranch = ({
  button1,
  isOpen,
  header,
  onCancel,
  onConfirm,
  message,
  list,
  onDisAprove,
  value,
  onChange,
  error,
  size = "lg",
}) => {
  const [detaillist, setdetaillist] = useState([]);
  const [askConfirm, setaskConfirm] = useState(false);
  // console.log("list=",list);
  const handleCancleSubmit = () => {
    setaskConfirm(false);
  };
  const handleConfirmSubmit = (event) => {
    // console.log("event",event)
    // const found = list.find((item) => item.DeliveryID === event);
    // if (found) {
    setdetaillist(event);
    setaskConfirm(true);
    // }
  };
  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={onCancel}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader>
          {list && list.length > 0 && (
            <span
              className="badge badge text-dark"
              style={{
                fontFamily: "-apple-system",
                fontSize: "1.2rem",
                fontWeight: 1.5,
                lineHeight: 1.5,
                color: "#292b2c",
                backgroundColor: "yellow",
                // padding: "0 1em"
              }}
            >
              เลขที่ใบชั่ง : {list[0].weight_no}
            </span>
          )}
        </ModalHeader>
        <ModalBody>
          <Modalconfirmbranch
            isOpen={askConfirm}
            onConfirm={onConfirm}
            onCancel={handleCancleSubmit}
            message={message}
            list={detaillist}
            button1="OK"
          />
          {list && list.length > 0 && (
            <div className="container-fluid">
              <div className="row" style={{ fontSize: "14px" }}>
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  <p className="font-weight-normal">
                    ประเภทลูกค้า : {list[0].CustomerTypeName}
                  </p>
                </div>
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  <p className="font-weight-normal">
                    ชื่อลูกค้า : {list[0].Customer_Name}
                  </p>
                </div>
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  <p className="font-weight-normal">
                    DO : {list[0].Delivery_No}
                  </p>
                </div>
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  <p className="font-weight-normal">
                    ทะเบียนรถ : {list[0].driven_no + ":" + list[0].DrivenProv}
                  </p>
                </div>
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  <p className="font-weight-normal">
                    ทะเบียนหาง :{" "}
                    {list[0].Second_driven_no +
                      ":" +
                      list[0].Second_driven_prov}
                  </p>
                </div>
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  <p className="font-weight-normal">
                    ปะเภทรถ : {list[0].trucktypename}
                  </p>
                </div>
              </div>
              <div className="row" style={{ fontSize: "14px" }}>
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  <p className="font-weight-normal">
                    ประเภทสินค้า : {list[0].Productname}
                  </p>
                </div>
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  <p className="font-weight-normal">
                    ชื่อสินค้า : {list[0].ProductName}
                  </p>
                </div>
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  <p className="font-weight-normal">
                    วัตถุประสงค์ : {list[0].aim_name}
                  </p>
                </div>
              </div>
              <div className="row" style={{ fontSize: "14px" }}>
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  <p className="font-weight-normal">
                    ที่ลงสินค้า : {list[0].store_name}
                  </p>
                </div>
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  <p className="font-weight-normal">
                    ประเภทเงินจ่าย : {list[0].TypePayName}
                  </p>
                </div>
              </div>
              <div className="row" style={{ fontSize: "14px" }}>
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  <p className="font-weight-normal">
                    นน.เข้า : {list[0].receive_weightin}
                  </p>
                </div>
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  <p className="font-weight-normal">
                    นน.ออก : {list[0].receive_weightout}
                  </p>
                </div>
                <div className="col-lg-4  col-sm-6 col-xs-12">
                  <p className="font-weight-normal">
                    นน.สุทธิ : {list[0].receive_weightnet}
                  </p>
                </div>
              </div>
            </div>
          )}
          {!list && message}
        </ModalBody>
        {error && <div className="col-md-12 alert alert-danger"> {error}</div>}

        {list && list.comment && <Button color="danger">{list.comment}</Button>}
        <ModalFooter>
          {list.length > 0 && list[0].progress == 0 && (
            <Button
              outline
              color="success"
              onClick={() => handleConfirmSubmit([{ data: list, action: "1" }])}
            >
              ชั่งเข้า
            </Button>
          )}
          {list.length > 0 && list[0].progress == 2 && (
            <div>
              <Button
                outline
                color="primary"
                onClick={() =>
                  handleConfirmSubmit([{ data: list, action: "2" }])
                }
              >
                ชั่งออก
              </Button>
              <Button outline color="danger" onClick={() => onConfirm(5)}>
                ยกเลิกชั่งเข้า
              </Button>
              <Button outline color="info" onClick={onCancel}>
                ปริ้นชั่งเข้า
              </Button>
            </div>
          )}

          {list.length > 0 && list[0].progress == 4 && (
            <div>
              <Button outline color="danger" onClick={() => onConfirm(6)}>
                ยกเลิกชั่งออก
              </Button>
              <Button outline color="info" onClick={() => onConfirm(3)}>
                ปริ้นชั่งเข้า
              </Button>
              <Button outline color="info" onClick={() => onConfirm(4)}>
                ปริ้นชั่งออก
              </Button>
            </div>
          )}

          <Button color="secondary" onClick={onCancel}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Modaldetailbranch;
